export default "__VITE_ASSET__CtRzoG6r__"